var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOnedrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7240_24321)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7240_24321",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 43,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01172 5H47.0118V47H5.01172V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7240_24321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01898 34.3337C9.22649 34.7568 9.05179 35.2679 8.62878 35.4754C8.20577 35.6829 7.69463 35.5082 7.48712 35.0852L9.01898 34.3337ZM15.4927 9.28905L15.9467 10.0113L15.9467 10.0114L15.4927 9.28905ZM7.48712 35.0852C2.89887 25.7321 6.02217 14.234 15.0387 8.56676L15.9467 10.0114C7.67713 15.2091 4.81117 25.7561 9.01898 34.3337L7.48712 35.0852ZM15.0387 8.56676C21.4983 4.50658 29.3431 4.4708 35.6376 7.78559L34.8425 9.29529C29.0645 6.25249 21.8701 6.28824 15.9467 10.0113L15.0387 8.56676Z",
    fill: "#8C8AE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4767 16.7186C42.2445 16.3086 42.3887 15.788 42.7987 15.5559C43.2087 15.3237 43.7293 15.4679 43.9614 15.8779L42.4767 16.7186ZM36.5291 42.7602L36.0751 42.0379L36.0751 42.0379L36.5291 42.7602ZM43.9614 15.8779C49.3583 25.4094 46.3518 37.5939 36.9831 43.4825L36.0751 42.0379C44.6682 36.6368 47.4263 25.4603 42.4767 16.7186L43.9614 15.8779ZM36.9831 43.4825C30.242 47.7196 22.0014 47.5666 15.583 43.8013L16.4463 42.3296C22.3379 45.7858 29.8947 45.9226 36.0751 42.0379L36.9831 43.4825Z",
    fill: "#8C8AE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5008 10.2958C41.5008 12.1988 39.9581 13.7415 38.0551 13.7415C36.1521 13.7415 34.6094 12.1988 34.6094 10.2958C34.6094 8.39285 36.1521 6.85017 38.0551 6.85017C39.9581 6.85017 41.5008 8.39285 41.5008 10.2958Z",
    fill: "#00D085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5485 41.0119C16.5485 42.9148 15.0058 44.4575 13.1029 44.4575C11.1999 44.4575 9.65723 42.9148 9.65723 41.0119C9.65723 39.1089 11.1999 37.5662 13.1029 37.5662C15.0058 37.5662 16.5485 39.1089 16.5485 41.0119Z",
    fill: "#FF6060"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7240_24321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1777 22.4203L23.178 22.4195L28.2162 25.4392L31.2184 24.175C31.8284 23.9111 32.4863 23.7758 33.1509 23.7765C33.2616 23.7765 33.3711 23.7815 33.48 23.7888C33.119 22.3804 32.3571 21.1073 31.2867 20.1242C30.2163 19.141 28.8835 18.4901 27.4504 18.2505C26.0173 18.011 24.5455 18.1931 23.2138 18.7747C21.8822 19.3564 20.748 20.3125 19.9492 21.527C19.9749 21.5267 20.0002 21.5251 20.0259 21.5251C21.1394 21.5235 22.2311 21.8336 23.1777 22.4203Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1775 22.4196L23.1772 22.4204C22.2306 21.8337 21.1389 21.5236 20.0254 21.5252C19.9997 21.5252 19.9744 21.5268 19.9487 21.5271C18.8589 21.5406 17.7933 21.851 16.8666 22.4249C15.9398 22.9989 15.1869 23.8147 14.6887 24.7847C14.1905 25.7547 13.9658 26.8421 14.0389 27.9303C14.112 29.0184 14.48 30.0661 15.1034 30.9606L19.5464 29.0898L21.5214 28.2581L25.9191 26.4064L28.2157 25.4393L23.1775 22.4196Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4796 23.7887C33.3707 23.7814 33.2612 23.7764 33.1505 23.7764C32.4859 23.7757 31.8282 23.9116 31.2182 24.1755L28.2158 25.4391L29.0864 25.9609L31.9401 27.6713L33.1852 28.4176L37.4424 30.9692C37.8292 30.2506 38.0297 29.4464 38.0254 28.6303C38.0212 27.8141 37.8123 27.012 37.418 26.2975C37.0237 25.5831 36.4565 24.979 35.7685 24.5407C35.0804 24.1024 34.2934 23.8438 33.4796 23.7887Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1852 28.4176L31.9401 27.6714L29.0864 25.961L28.2158 25.4392L25.9192 26.4062L21.5216 28.258L19.5465 29.0897L15.1035 30.9605C15.6556 31.7548 16.3917 32.4036 17.2488 32.8515C18.1059 33.2994 19.0586 33.5331 20.0255 33.5326H33.1505C34.0305 33.5328 34.8942 33.2947 35.6499 32.8434C36.4055 32.3921 37.0249 31.7445 37.4424 30.9693L33.1852 28.4176Z",
    fill: "#28A8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7240_24321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.0001,
    height: 42,
    fill: "white",
    transform: "translate(5 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7240_24321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.3846,
    fill: "white",
    transform: "translate(14.0254 18.1479)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnedrive);
export default __webpack_public_path__ + "static/media/icon_onedrive.7f81e935a812f8fc4217bce887c2582f.svg";
export { ForwardRef as ReactComponent };